import { ModalContent, Typography } from '@client/toolkit';
import { Trans, useTranslation } from 'react-i18next';

export const DeleteConfirmationModalContent = ({ name }: { name: string }) => {
  const { t: tCommon } = useTranslation();
  return (
    <ModalContent>
      <div className="uppercase text-xs font-semibold p-4 text-center text-white">{tCommon('delete')}</div>
      <Typography align="center" className="px-4 py-4 text-white">
        <Trans t={tCommon} i18nKey={'deleteConfirm'} values={{ name }} components={{ bold: <strong /> }} />
      </Typography>
    </ModalContent>
  );
};
